import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default {
  __name: 'BadgeNew',
  props: {
  style_css: {
    type: String,
    default: 'crm:absolute crm:top-[-15px] crm:right-[-8px] crm:rounded-full crm:bg-[#F9604E] crm:text-white crm:w-[30px] crm:h-[30px] crm:font-bold crm:flex crm:justify-center crm:items-center crm:uppercase crm:text-xs crm:rotate-[-10deg]'
  }
},
  setup(__props) {

/**
 * @doc renderizza il badge di novità
 */
const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.style_css)
  }, "New", 2 /* CLASS */))
}
}

}